import React from 'react'
import { Link } from 'react-router-dom'

import { Fieldset, Legend } from '@paytrace/pt-skel/Component'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import { getSubmittedData } from '@paytrace/pt-skel/Helper'
import { useMountUnmount } from '@paytrace/pt-skel/Hooks'
import Event from '../Event'

interface Props { }

const self = Symbol('SettleTransactions')

export function SettleTransactions (props: Props) {
  useMountUnmount(() => {
    PubSub.sub(self, Event.SEARCH_TRANSACTIONS_RESPONSE, (json) => {
      // TODO: handle the response
    })

    return () => {
      PubSub.unsub(self)
    }
  })

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()

    PubSub.pub('VALIDATION_ERROR::clear')

    // TODO: properly map to the request
    const formData = getSubmittedData(e)
    PubSub.pub(
      Event.SEARCH_TRANSACTIONS_REQUEST,
      { ...formData }
    )

    return false
  }

  return (
    <>
      <div className='float-right'>
        <a className='help-link' href="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2027716999/Settle+Transactions">Help</a>
      </div>
      <h1>Settle Transactions</h1>
      <hr className='clear' />

      <form onSubmit={submit}>
        <Fieldset>
          <Legend title='Search Results'>
            <div className='float-right'>
              <Link className='link-btn' to='/viewsettle.pay'>Printable View</Link>
              <Link className='link-btn' to='/download.pay?type=exportpendingsettlement'>Download</Link>
              <Link className='link-btn' to='/download.pay?type=exportpendingsettlementdetails'>Download Details</Link>
            </div>
          </Legend>
          <div className='clear' />

          <div className='info-msg msg-space'>No transactions are pending settlement.</div>
        </Fieldset>

        <button className='primary-btn form-btn'>Settle</button>
      </form>
    </>
  )
}

export default SettleTransactions
